import React from "react";
import { confirmDialog } from "primereact/confirmdialog";
import { Formik, Form } from "formik";
import dompurify from "dompurify";
import PageWrapper from "../../../../PageWrapper";
import PrimaryButton from "../../../../SFUCentralThemedComponents/PrimaryButton";
import Checkbox from "../../../../GenericFormikComponents/Checkbox";
import CheckboxGroup from "../../../../GenericFormikComponents/CheckboxGroup";
import Label from "../../../../Label";

import { useCollectionNotice } from "../../../../../hooks/useCollectionNotice";
import { validationSchema, initialValues } from "./validationSchema";

export default function SubmissionPage({
  goToPage,
  pageInfo,
  savePage,
  steppers,
  calculateFinancialNeed,
  saveMarginalizedGroupTags,
}) {
  const collectionNotice = useCollectionNotice();

  function submitApp() {
    calculateFinancialNeed();
    saveMarginalizedGroupTags();
    savePage({ status: "Completed" });
    goToPage("ConfirmationPage");
    window.scrollTo(0, 0);
  }

  const confirmSubmisson = (event) => {
    confirmDialog({
      target: event.currentTarget,
      message:
        "Are you sure you want to submit your application? No further changes are allowed after submission.",
      header: "Submission",
      acceptLabel: "Submit",
      rejectLabel: "Continue Editing",
      acceptIcon: "pi pi-check",
      rejectIcon: "pi pi-arrow-left",
      icon: "pi pi-exclamation-triangle",
      accept: submitApp,
      reject: () => {},
    });
  };

  return (
    <PageWrapper>
      {steppers(pageInfo.pageNum)}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema(
          collectionNotice.data
            ? collectionNotice.data.consent_text_array.length
            : 4
        )} // validation schema is defined at the top of the page
        onSubmit={confirmSubmisson}
      >
        {() => (
          <Form>
            <div className="p-grid">
              <div className="p-col-12">
                <h1>Collection Notice</h1>
              </div>

              <div className="p-col-12">
                <h4>
                  {`Once you complete this page you will no longer be able to make changes to this application. By clicking the 'Submit' button you agree to the following: `}
                </h4>

                {collectionNotice.data ? (
                  <div className="p-grid">
                    <div className="p-col-12">
                      <CheckboxGroup name="consent">
                        {collectionNotice.data.consent_text_array.map(
                          (consent, i) => (
                            <Label>
                              <div style={{ display: "flex" }}>
                                <Checkbox
                                  inputId="consent"
                                  name="consent"
                                  value={`consent${i + 1}`}
                                />
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: dompurify.sanitize(consent),
                                  }}
                                />
                              </div>
                              <br />
                              <br />
                            </Label>
                          )
                        )}
                      </CheckboxGroup>
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: dompurify.sanitize(
                          collectionNotice.data.collection_notice_text
                        ),
                      }}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="p-grid button-navigation-container">
              <div className="p-col-12">
                <PrimaryButton
                  type="button"
                  onClick={() => {
                    goToPage(pageInfo.pageNum - 1);
                  }}
                >
                  Back
                </PrimaryButton>
                <PrimaryButton
                  id="submitButton"
                  type="submit"
                  className="push-right"
                >
                  Submit
                </PrimaryButton>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </PageWrapper>
  );
}
